"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { AlertCircle, RefreshCw, Search, Home } from "lucide-react";
import Link from "next/link";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function ListingError({ error, reset }: ErrorProps) {
  useEffect(() => {
    console.error("İlan yüklenirken hata oluştu:", error);
  }, [error]);

  // 404 benzeri hata kontrolü
  const isNotFound = error.message.includes("not found") || error.message.includes("bulunamadı");

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 py-16">
      <div className="mx-auto max-w-md text-center">
        {/* Hata İkonu */}
        <div className="mb-6 flex justify-center">
          <div className={`rounded-full p-4 ${isNotFound ? "bg-muted" : "bg-destructive/10"}`}>
            {isNotFound ? (
              <Search className="text-muted-foreground h-12 w-12" />
            ) : (
              <AlertCircle className="text-destructive h-12 w-12" />
            )}
          </div>
        </div>

        {/* Başlık */}
        <h1 className="text-foreground mb-2 text-2xl font-bold">
          {isNotFound ? "İlan Bulunamadı" : "İlan Yüklenemedi"}
        </h1>

        {/* Açıklama */}
        <p className="text-muted-foreground mb-6">
          {isNotFound
            ? "Aradığınız ilan mevcut değil veya kaldırılmış olabilir. Lütfen başka ilanları inceleyin."
            : "İlan yüklenirken bir sorun oluştu. Lütfen tekrar deneyin veya başka ilanları inceleyin."}
        </p>

        {/* Hata Detayı (Development modda) */}
        {process.env.NODE_ENV === "development" && error.message && (
          <div className="bg-muted mb-6 rounded-lg p-4 text-left">
            <p className="text-muted-foreground font-mono text-sm">{error.message}</p>
          </div>
        )}

        {/* Aksiyonlar */}
        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          {!isNotFound && (
            <Button onClick={reset} variant="default" className="gap-2">
              <RefreshCw className="h-4 w-4" />
              Tekrar Dene
            </Button>
          )}
          <Button asChild variant="outline" className="gap-2">
            <Link href="/listings">
              <Search className="h-4 w-4" />
              Tüm İlanları Gör
            </Link>
          </Button>
          <Button asChild variant="ghost" className="gap-2">
            <Link href="/">
              <Home className="h-4 w-4" />
              Ana Sayfa
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
